(function (window, document, Chartist) {
    'use strict';
    var defaultOptions = {
        labelClass: 'ct-pie-label',
        labelInterpolationFnc: Chartist.noop,
        labelOffset: {
            x: 0,
            y: 0
        },
        position: {
            x: null,
            y: null
        }
    };
    
    Chartist.plugins = Chartist.plugins || {};
    Chartist.plugins.ctPieLabels = function (options) {
        options = Chartist.extend({}, defaultOptions, options);
        
        var positionX = options.position.x || function (data) {
            var cx = data.center.x;
            var cy = data.center.y;
            var radius = data.radius;
            // Subtracting by 90 so that it matches the origin point for circles in Chartist, which is at the top... 
            var angleMidpoint = (data.startAngle + data.endAngle) / 2 - 90 + options.labelOffset.x;
            
            return radius * Math.cos(angleMidpoint * Math.PI / 180) + cx;
        };
        
        var positionY = options.position.y || function (data) {
            var cy = data.center.y;
            var radius = data.radius;
            // Subtracting by 90 so that it matches the origin point for circles in Chartist, which is at the top...
            var angleMidpoint = (data.startAngle + data.endAngle) / 2 - 90;
            
            return radius * Math.sin(angleMidpoint * Math.PI / 180) + cy + options.labelOffset.y;
        };
        
        return function ctPieLabels (chart) {
            if (chart instanceof Chartist.Pie) {
                chart.on('draw', function (data) {
                    if (data.type === 'slice') {
                        data.group.elem('text', {
                            x: positionX(data),
                            y: positionY(data),
                            style: 'text-anchor: middle'
                        }, options.labelClass)
                            .text(
                                options.labelInterpolationFnc(data.value, data.totalDataSum)
                            );
                    }
                });
            }
        };
    };
}(window, document, Chartist));